import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { StorageService } from '../storage.service';
import { ValidationService } from '../validation.service';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { DateTime } from 'luxon';
import { MatDialog } from '@angular/material/dialog';
import { CommonTableComponent } from '../common-table/common-table.component';
import { TimeService } from '../time.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-control-room',
  templateUrl: './control-room.component.html',
  styleUrls: ['./control-room.component.scss']
})
export class ControlRoomComponent implements OnInit {

  showLoader = false;
  fromDate: any;
  toDate: any;
  minDate = new Date(2022, 11, 9);
  tabIndex = 0;
  activelyTrackingInfo:boolean;
  passivelytrackingInfo:boolean;
  nontrackingInfo:boolean;
  noGpsInfo:boolean;
  tracking: any = [

  ];
  nonTracking: any = [

  ];

  nonTracking2: any = [];

  nonData: any = [['noData', 0]];
  non_tracking = [];
  trackingCount: any = { count: 0, shipments: [] };
  nonTrackingCount: any = { count: 0, shipments: [] };
  vehiclePathReportRef: any;
  withGps: any = { count: 0, shipments: [] };
  withoutGps: any = { count: 0, shipments: [] };
  running: any = { name: 'Running', count: 0, shipments: [] };
  halt: any = { count: 0, shipments: [], name: 'Halt' };
  idle: any = { count: 0, shipments: [], name: 'Idle' };
  offline: any = { count: 0, shipments: [], name: 'Offline' };
  dead: any = { count: 0, shipments: [], name: 'Dead' };
  activelytracking: any = { count: 0, shipments: [] };
  passivelytracking: any = { count: 0, shipments: [] };
  nonTrackingg: any = { count: 0, shipments: [] };
  total = 20;
  g = 0;
  g_at = 0;
  g_at_halt = 0;
  g_at_running = 0;
  g_at_idle = 0;
  g_pt: 0;
  g_pt_short_offline = 0;
  g_pt_long_offline = 0
  g_nt = 0;
  g_nt_dead = 0;
  g_nt_never_alive = 0;
  ng = 0;
  vehicleFilters: any = {};
  selectedShipper: any;
  vehicleflow: any
  vehicleStageWiseSummary: any;
  inplantStagging: any;
  stagingHrsSlab: any;
  intransitByWeight: any;
  delayedByDuration: any;
  delaysByHaltDuration: any;
  towardsPickupAngul: any;
  customerDetention: any;
  control_tower_filter = {
    timeframe: '',
    material: '',
    ship_to_city: '',
    carrier: '',
    is_all_unit: false,
  }
  carrierId: Subscription;
  isJSPLRaigarh: Boolean = false;
  dialogRef: any;
  gpsTrackingData: any[];
  parked: any = { count: 0, shipments: [], name: 'Parked' };
  irregular: any = { count: 0, shipments: [], name: 'Irregular' };
  tempOffline: any = { count: 0, shipments: [], name: 'Temporary Offline' };
  neverAlive: any = { count: 0, shipments: [], name: 'Never Activated' };
  noGps: any = { count: 0, shipments: [], name: 'No GPS' };
  totalGpsVehicles = 0;
  passivelyTrackingCount: any;
  vehicleFlowCount = 0;
  vehicleStageCount = 0;
  inPlantStageCount = 0;
  inPlantTatCount = 0;
  enrouteComplianceCount = 0;
  enrouteCarrierCount = 0;
  enrouteDelayCount = 0;
  customerDetentionCount = 0;
  units:any;
  towardsAngulPickupCount = 0;
  constructor(private http: HttpService, private events: EventService, private valid: ValidationService, private storage: StorageService, private snackbar: SnackbarService, private dialog: MatDialog, private timeService: TimeService) { }

  ngOnInit(): void {
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getDateRange();
      },
      (err: any) => {

      }
    );
    const shipperData = JSON.parse(localStorage.getItem("shippers"));
    // this.units=shipperData[0].parent_name;
    this.isJSPLRaigarh = true;
    this.selectedShipper = this.storage.getFromCookie('shipper_id');
    this.vehicleFilters.dedicated_to = this.selectedShipper;

    let currendateTime: any = DateTime.local().minus({ days: 30 });
    this.fromDate = new Date(currendateTime);
    this.toDate = new Date();
    this.getDateRange();

  }
  switchTab(tab: number) {
    this.tabIndex = tab;
    this.loadTabWiseData();
  }
  getHoursandMinutes(seconds) {
    return this.timeService.getHoursMinutes(seconds);
  }
  getVehicleTrackingBreakup() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from: from,
      to: to,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }
    this.trackingCount = { count: 0, shipments: [] };
    this.nonTrackingCount = { count: 0, shipments: [] };
    this.vehiclePathReportRef;
    this.withGps = { count: 0, shipments: [] };
    this.withoutGps = { count: 0, shipments: [] };
    this.running = { name: 'Running', count: 0, shipments: [] };
    this.halt = { count: 0, shipments: [] };
    this.idle = { count: 0, shipments: [] };
    this.offline = { count: 0, shipments: [] };
    this.dead = { count: 0, shipments: [] };
    this.activelytracking = { count: 0, shipments: [] };
    this.passivelytracking = { count: 0, shipments: [] };
    this.nonTrackingg = { count: 0, shipments: [] };

    this.http.post('stats/cr/vehicle_tracking_breakup', payload, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          this.totalGpsVehicles = res.reduce((a, b) => a + b.total, 0);
          // console.log("🚀 ~ file: vehicles.component.ts:415 ~ VehiclesComponent ~ getVehicleTrackingBreakup ~ res", res);
          this.gpsTrackingData = [];
          res.forEach(e => {
            if (e._id === 'g_at_running') {
              this.running = {
                count: e.total || 0,
                shipments: e.shipments || [],
                name: 'Running',
              };

            } else if (e._id === 'g_at_idle') {
              this.idle = {
                count: e.total || 0,
                shipments: e.shipments || [],
              };
              this.idle.name = 'Idle';
            } else if (e._id === 'g_at_parked') {
              this.parked = {
                count: e.total || 0,
                shipments: e.shipments || [],
              };
              this.parked.name = 'Parked';
            } else if (e._id === 'g_pt_irregular') {
              this.irregular = {
                count: e.total || 0,
                shipments: e.shipments || [],
              };
              this.irregular.name = 'Irregular';
            } else if (e._id === 'g_pt_temp_offline') {
              this.tempOffline = {
                count: e.total || 0,
                shipments: e.shipments || [],
              };
              this.tempOffline.name = 'Temporary Offline'
            } else if (e._id === 'g_nt_offline') {
              this.offline = {
                count: e.total || 0,
                shipments: e.shipments || [],
              };
              this.offline.name = 'Offline'
            } else if (e._id === 'g_nt_never_alive') {
              this.neverAlive = {
                count: e.total || 0,
                shipments: e.shipments || [],
              };
              this.neverAlive.name = 'Never Activated'
            } else if (e._id === 'ng') {
              this.noGps = {
                count: e.total || 0,
                shipments: e.shipments || [],
              };
              this.noGps.name = 'No Gps Installed'
            }

          });
          this.nonTracking2 = [
            // ['offline', res.g_pt_short_offline + res.g_pt_long_offline + res.g_nt_dead],
            this.irregular,
            this.tempOffline
          ];
          this.passivelyTrackingCount = this.nonTracking2.reduce((acc, b) => acc + b.count, 0);


          this.tracking = [
            this.running,
            this.idle,
            this.parked,
          ];
          this.trackingCount = this.tracking.reduce((acc, b) => acc + b.count, 0);
          this.nonTracking = [
            this.offline,
            this.neverAlive,
          ];
          this.nonTrackingCount = this.nonTracking.reduce((acc, b) => acc + b.count, 0);


          this.nonData = [
            this.noGps,
          ];
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          // this.valid.logout();
        }
      }
    );
  }

  getDateRange() {
    if (this.fromDate && this.toDate) {
      this.loadTabWiseData();

    }
  }
  loadTabWiseData() {
    if (this.tabIndex == 0) {
      this.getVehicleFlow();
      this.getVehicleStageWiseSummary();
      this.getVehicleTrackingBreakup();
    } else if (this.tabIndex == 1) {
      this.getInplantStagging();
      this.getHoursSlab();
    } else if (this.tabIndex == 2) {
      this.getIntransitByWeight();
      this.getDelayedByDuration();
      this.getDelayByHaltDuration();
      this.getCustomerDetention();
    } else if (this.tabIndex == 3) {
      this.getTowardsPickupAngul();
    }

  }
  getVehicleFlow() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from: from,
      to: to,
      all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/gps_vehicle/vehicleFlow', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.vehicleflow = response.data;
          this.vehicleFlowCount = this.vehicleflow.reduce((acc, b) => acc + b.vehicles, 0);
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getVehicleStageWiseSummary() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from: from,
      to: to,
      all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/gps_vehicle/vehicleStageWiseSummary', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        this.vehicleStageCount = 0;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.vehicleStageWiseSummary = response.data;
          this.vehicleStageCount = this.vehicleStageWiseSummary.reduce((acc, b) => acc + b.vehicles, 0);
          // const object = this.vehicleStageWiseSummary[0];
          // for (const key in object) {

          //   if (key.toString().includes('count')) {
          //     this.vehicleStageCount += object[key];
          //   }

          // }
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getInplantStagging() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from_date: from,
      to_date: to,
      // all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/staging_live', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.inplantStagging = response.data;
          this.inPlantStageCount = this.inplantStagging.reduce((acc, b) => acc + b.no_of_trips, 0);
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getHoursSlab() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from_date: from,
      to_date: to,
      // all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/staging_hr_slab', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.stagingHrsSlab = response.data;
          this.inPlantTatCount = this.stagingHrsSlab.reduce((acc, b) => acc + b.total_no_of_trips, 0);
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getIntransitByWeight() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from_date: from,
      to_date: to,
      // all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/in_transit_by_weight', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.intransitByWeight = response.data;
          this.enrouteCarrierCount = this.intransitByWeight.reduce((a, b) => a + b.no_of_trips, 0);

          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getDelayedByDuration() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from: from,
      to: to,
      // all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/enroute_delayed_by_duration', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.delayedByDuration = response.data;
          this.enrouteComplianceCount = this.delayedByDuration.reduce((a, b) => a + b.vehicles, 0);
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getDelayByHaltDuration() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from: from,
      to: to,
      // all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/enroute_delay_and_halt_duration', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.delaysByHaltDuration = response.data;
          this.enrouteDelayCount = this.delaysByHaltDuration.reduce((a, b) => a + b.vehicles, 0);
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getTowardsPickupAngul() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from: from,
      to: to,
      // all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/towards_pickup/angul', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.towardsPickupAngul = response.data;
          this.towardsAngulPickupCount = this.towardsPickupAngul.reduce((acc, b) => acc + b.vehicles, 0);
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }
  getCustomerDetention() {
    let from: any = "",
      to: any = "";

    if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    } else if (this.fromDate && this.toDate) {
      from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
      to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    }
    let payload = {
      from: from,
      to: to,
      // all: false,
      timeframe: this.control_tower_filter.timeframe,
      material: this.control_tower_filter.material,
      ship_to_city: this.control_tower_filter.ship_to_city,
      carrier: this.control_tower_filter.carrier,
    };
    if (this.control_tower_filter.timeframe == '') {
      delete payload.timeframe
    }
    if (this.control_tower_filter.material == '') {
      delete payload.material
    }
    if (this.control_tower_filter.ship_to_city == '') {
      delete payload.ship_to_city
    }
    if (this.control_tower_filter.carrier == '') {
      delete payload.carrier
    }

    this.showLoader = true;
    this.http.post('stats/cr/detention', payload, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          // if (response && response.length > 0) {
          this.customerDetention = response.data;
          this.customerDetentionCount = this.customerDetention.reduce((a, b) => a + b.no_of_trips, 0);
          // } 
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );


  }

  showdDetails(item) {
    this.http.post('shipment/details', { _ids: item.shipments }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const displayedColumns = ['SNo','SIN', 'Vehicle', 'Delivery','Driver', 'Driver Mobile', 'City', 'State', 'Carrier', 'OBD No.', 'Gate Out Time'];
          const title = item.title;
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SNo=i+1;
            temp.SIN = e.SIN;
            temp.tracker = environment.TRACKER_URL + e.unique_code;
            temp.Vehicle = e.vehicle_no;
            temp.Delivery = e.deliveries[0].location.name || '';
            temp.City = e.deliveries[0].location.city || '';
            temp.State = e.deliveries[0].location.locality || '';
            temp.Carrier = e.carrier.parent_name || '';
            temp['OBD No.'] = e.do_numbers.join(', ');
            temp['Gate Out Time'] = e.events.filter((e) => e.event_name === 'GO')[0] ? this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp) : '';
            temp.Driver = e.driver.name || '';
            temp['Driver Mobile'] = e.driver.mobile || '';
            // temp['Gate In No.'] = e.driver.gate_entry_no || '';
            // temp['Gate In Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GI')[0].event_timestamp);
            dataSource.push(temp);
          });
          const shipmentIds = res.map(r => r._id);
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                shipmentIds,
                shipmentType: 'all',
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  showdInPlantDetails(item) {
    this.http.post('shipment/details', { _ids: item.shipments }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const displayedColumns = ['SNo','SIN', 'Gate In No.', 'Gate In Time', 'Gate In Duration (HH:MM)', 'OBD No.', 'Vehicle', 'Driver', 'Driver Mobile', 'Delivery', 'Current Stage', 'Current Stage Time', 'Current Stage Duration (HH:MM)', 'Materials', 'Invoice Weight (MT)', 'Carrier'];
          const title = item.title;
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SNo=i+1;
            temp.SIN = e.SIN;
            temp.tracker = environment.TRACKER_URL + e.unique_code;
            temp['Gate In No.'] = e.driver.gate_entry_no || '';
            temp['Gate In Time'] = e.events.filter((e) => e.event_name === 'GI')[0] ? this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GI')[0].event_timestamp) : '';
            const date1 = DateTime.fromJSDate(new Date());
            const date2 = DateTime.fromJSDate(new Date(temp['Gate In Time']));
            temp['Gate In Duration (HH:MM)'] = this.timeService.convertMsToHM(Math.round(date1.diff(date2, ['milliseconds']).milliseconds));
            temp.Vehicle = e.vehicle_no;
            temp.Driver = e.driver.name || '';
            temp['Driver Mobile'] = e.driver.mobile || '';
            temp['Current Stage'] = e.event_status;
            temp['Current Stage Time'] = e.events.filter((e) => e.event_name === temp['Current Stage'])[0] ? this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === temp['Current Stage'])[0].event_timestamp) : '';
            const date3 = DateTime.fromJSDate(new Date());
            const date4 = DateTime.fromJSDate(new Date(temp['Current Stage Time']));
            temp['Current Stage Duration (HH:MM)'] = this.timeService.convertMsToHM(Math.round(date3.diff(date4, ['milliseconds']).milliseconds));
            temp.Delivery = e.deliveries[0].location.name || '';
            temp.Materials = e.materials.map(m => m.name).join(', ');
            temp['Invoice Weight (MT)'] = e.events.filter((e) => e.event_name === 'IV')[0] ? e.events.filter((e) => e.event_name === 'IV')[0].attributes.weight : '';
            temp.Carrier = e.carrier.parent_name || '';
            temp['OBD No.'] = e.do_numbers.join(', ');
            // temp['Gate In Duration'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp);
            dataSource.push(temp);
          });
          const shipmentIds = res.map(r => r._id);
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                shipmentIds,
                shipmentType: 'all',
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  showdInTATPlantDetails(item) {
    const shipments = item.shipments.reduce((acc, cur) => acc.concat(cur.shipments), []);
    this.http.post('shipment/details', { _ids: shipments }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const displayedColumns = ['SNo','SIN', 'Gate In No.', 'Gate In Time', 'Gate In Duration (HH:MM)', 'OBD No.', 'Vehicle', 'Driver', 'Driver Mobile', 'Delivery', 'Current Stage', 'Current Stage Time', 'Current Stage Duration (HH:MM)', 'Materials', 'Invoice Weight (MT)', 'Carrier'];
          const title = item.title;
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SNo=i+1;
            temp.SIN = e.SIN;
            temp.tracker = environment.TRACKER_URL + e.unique_code;
            temp['Gate In No.'] = e.driver.gate_entry_no || '';
            temp['Gate In Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GI')[0].event_timestamp);
            const date1 = DateTime.fromJSDate(new Date());
            const date2 = DateTime.fromJSDate(new Date(temp['Gate In Time']));
            temp['Gate In Duration (HH:MM)'] = this.timeService.convertMsToHM(Math.round(date1.diff(date2, ['milliseconds']).milliseconds));
            temp.Vehicle = e.vehicle_no;
            temp.Driver = e.driver.name || '';
            temp['Driver Mobile'] = e.driver.mobile || '';
            temp['Current Stage'] = e.event_status;
            temp['Current Stage Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === temp['Current Stage'])[0].event_timestamp);
            const date3 = DateTime.fromJSDate(new Date());
            const date4 = DateTime.fromJSDate(new Date(temp['Current Stage Time']));
            temp['Current Stage Duration (HH:MM)'] = this.timeService.convertMsToHM(Math.round(date3.diff(date4, ['milliseconds']).milliseconds));
            temp.Delivery = e.deliveries[0].location.name || '';
            temp.Materials = e.materials.map(m => m.name).join(', ');
            temp['Invoice Weight (MT)'] = e.events.filter((e) => e.event_name === 'IV')[0] ? e.events.filter((e) => e.event_name === 'IV')[0].attributes.weight : '';
            temp.Carrier = e.carrier.parent_name || '';
            temp['OBD No.'] = e.do_numbers.join(', ');
            // temp['Gate In Duration'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp);
            dataSource.push(temp);
          });
          const shipmentIds = res.map(r => r._id);
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                shipmentIds,
                shipmentType: 'all',
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  showEnrouteDetails(item) {
    this.http.post('shipment/details', { _ids: item.shipments }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const displayedColumns = ['SNo','SIN', 'Gate In No.', 'Gate Out Time', 'Vehicle', 'Driver', 'Driver Mobile', 'Carrier', 'Carrier Support', 'PDD', 'Destination', 'City', 'State', 'OBD No.'];
          const title = item.title;
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SNo=i+1;
            temp.SIN = e.SIN;
            temp.tracker = environment.TRACKER_URL + e.unique_code;
            temp['Gate In No.'] = e.driver.gate_entry_no || '';
            temp['Gate Out Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp);
            temp.Vehicle = e.vehicle_no;
            temp.Driver = e.driver.name || '';
            temp['Driver Mobile'] = e.driver.mobile || '';
            temp.Carrier = e.carrier.parent_name || '';
            temp['Carrier Support'] = e.carrier.support_no || '';
            temp['OBD No.'] = e.do_numbers.join(', ');
            temp.PDD = this.timeService.toShortDateTime24(e.delivery_date);
            temp.Destination = e.deliveries[0].location.name || '';
            temp.City = e.deliveries[0].location.city || '';
            temp.State = e.deliveries[0].location.locality || '';

            // temp['Gate In Duration'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp);
            dataSource.push(temp);
          });
          const shipmentIds = res.map(r => r._id);
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                shipmentIds,
                shipmentType: 'all',
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  showdGPSDetails(item) {
    if(item.shipments.length>0){
    this.http.post('shipment/details', { _ids: item.shipments }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const displayedColumns = ['SNo','SIN', 'Vehicle', 'Driver', 'Driver Mobile', 'GPS Provider', 'Carrier', 'Carrier Mobile', 'Gate Out Time','Last GPS Pinged'];
          const title = item.title;
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SIN = e.SIN;
            temp.tracker = environment.TRACKER_URL + e.unique_code;
            temp.SNo=i+1;
            temp.Vehicle = e.vehicle_no;
            temp.Driver = e.driver.name || '';
            temp['Driver Mobile'] = e.driver.mobile || '';
            temp.Carrier = e.carrier.parent_name || '';
            temp['Carrier Mobile'] = e.carrier.support_no || '';
            temp['Carrier Email'] = e.carrier.email || '';
            temp['Gate Out Time'] = e.events.filter((e) => e.event_name === 'GO')[0] ? this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp) : '';
            temp['Last GPS Pinged'] = this.timeService.toShortDateTime24(e.driver.gps_updated_at);
            temp.coordinates = e.driver.geo_point? e.driver.geo_point.coordinates:[];
            let gpsProvider = '';
            if (e.driver.gps && e.driver.gps.provider) gpsProvider = e.driver.gps.provider;
            else if (e.driver.vehicle && e.driver.vehicle.gps && e.driver.vehicle.gps.provider) gpsProvider = e.driver.vehicle.gps.provider;
            temp['GPS Provider'] = gpsProvider;
            dataSource.push(temp);
          });
          const shipmentIds = res.map(r => r._id);
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                shipmentIds,
                shipmentType: 'all',
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
    }else{
      this.snackbar.openSnackBar("No data found ", "", "err");
    }
  }
  showCustomerDetention(item) {
    this.http.post('shipment/details', { _ids: item.shipments }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const displayedColumns = ['SNo','SIN', 'Gate Out Time', 'Vehicle', 'Driver', 'Driver Mobile', 'Destination', 'Customer In Time', 'Detention Details', 'Geofence Availability', 'Carrier'];
          const title = item.title;
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SNo=i+1;
            temp.SIN = e.SIN;
            temp.tracker = environment.TRACKER_URL + e.unique_code;
            temp['Gate In No.'] = e.driver.gate_entry_no || '';
            temp['Gate In Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GI')[0].event_timestamp).toString();
            temp['Gate Out Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp).toString();
            temp.Vehicle = e.vehicle_no;
            temp.Driver = e.driver.name || '';
            temp['Driver Mobile'] = e.driver.mobile || '';
            temp.Carrier = e.carrier.parent_name || '';
            temp.PDD = this.timeService.toShortDateTime24(e.delivery_date);
            temp.Destination = e.deliveries[0].location.name || '';
            temp['Customer In Time'] = this.timeService.toShortDateTime24(e.deliveries[0].arrived_at);
            const date1 = DateTime.fromJSDate(new Date());
            const date2 = DateTime.fromJSDate(new Date(e.deliveries[0].arrived_at));
            temp['Detention Details'] = this.timeService.convertMsToHM(Math.round(date1.diff(date2, ['milliseconds']).milliseconds));
            temp['Geofence Availability'] = e.deliveries[0].location.polylines.length ? 'Yes' : 'No';
            temp.Carrier = e.carrier.parent_name || '';
            // temp['Gate In Duration'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp);
            dataSource.push(temp);
          });
          const shipmentIds = res.map(r => r._id);
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                shipmentIds,
                shipmentType: 'all',
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  showVehicleStageDetails(item) {
    this.http.post('shipment/details', { _ids: item.shipments }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const title = item.title;
          let displayedColumns = ['SNo','SIN', 'Vehicle', 'Driver', 'Driver Mobile', 'Delivery', 'City', 'State', 'Carrier', 'OBD No.', 'Gate In Time', 'Gate In Duration (HH:MM)', 'Current Stage', 'Current Stage Time', 'Current Stage Duration (HH:MM)', 'Material', 'OBD Issue Time'];
          if (title === 'Enroute') displayedColumns = ['SIN', 'Vehicle','Driver', 'Driver Mobile', 'Delivery', 'City', 'State', 'Carrier', 'Carrier Support', 'OBD No.', 'Gate Out Time', 'PDD'];
          if (title === 'DO Issued') displayedColumns = ['SIN', 'Vehicle','Driver', 'Driver Mobile', 'Delivery', 'OBD No.', 'OBD Issue Time', 'Preferred Load (MT)'];
          if (title === 'At Customer Site') displayedColumns = ['SIN', 'Vehicle','Driver', 'Driver Mobile', 'Delivery', 'OBD No.', 'Gate Out Time', 'Customer In Time', 'Detention (HH:MM)'];
          if (title === 'Waiting for DO') displayedColumns = ['Trip Id', 'Materials', 'Preferred Customer', 'Load (MT)'];
          if (title === 'PO-GI') displayedColumns = ['SIN', 'Vehicle', 'Delivery', 'City', 'State', 'Carrier', 'OBD No.', 'Current Stage', 'Current Stage Time', 'Current Stage Duration (HH:MM)', 'Materials'];
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SNo=i+1;
            temp.SIN = e.SIN;
            temp.tracker = environment.TRACKER_URL + e.unique_code;
            temp.Vehicle = e.vehicle_no;
            temp.Delivery = e.deliveries[0].location.name || '';
            temp.City = e.deliveries[0].location.city || '';
            temp.State = e.deliveries[0].location.locality || '';
            temp.Carrier = e.carrier.parent_name || '';
            temp['OBD No.'] = e.do_numbers.join(', ');
            temp['Gate In Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GI')[0].event_timestamp);
            temp['Gate Out Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GO')[0].event_timestamp);
            const date1 = DateTime.fromJSDate(new Date());
            const date2 = DateTime.fromJSDate(new Date(temp['Gate In Time']));
            temp['Gate In Duration (HH:MM)'] = this.timeService.convertMsToHM(Math.round(date1.diff(date2, ['milliseconds']).milliseconds));
            temp['Current Stage'] = e.event_status;
            temp['Current Stage Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === temp['Current Stage'])[0].event_timestamp);
            const date3 = DateTime.fromJSDate(new Date());
            const date4 = DateTime.fromJSDate(new Date(temp['Current Stage Time']));
            temp['Current Stage Duration (HH:MM)'] = this.timeService.convertMsToHM(Math.round(date3.diff(date4, ['milliseconds']).milliseconds));
            temp.Material = e.materials.map(material => material.name).join(', ');
            temp['OBD Issue Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'DC')[0].event_timestamp);
            temp['Carrier Support'] = e.carrier.support_no || '';
            temp['Preferred Load (MT)'] = e.driver.desired_weight || '';
            temp['Customer In Time'] = this.timeService.toShortDateTime24(e.deliveries[0].arrived_at);
            const date5 = DateTime.fromJSDate(new Date());
            const date6 = DateTime.fromJSDate(new Date(e.deliveries[0].arrived_at));
            temp['Detention (HH:MM)'] = this.timeService.convertMsToHM(Math.round(date5.diff(date6, ['milliseconds']).milliseconds));
            temp['Trip Id'] = e.driver.registration_number || '';
            temp.Materials = e.driver.materials.map(material => material.name).join(', ');
            temp['Preferred Customer'] = e.driver.customer_name || '';
            temp['Load (MT)'] = e.driver.desired_weight || 0;
            temp.PDD = this.timeService.toShortDateTime24(e.delivery_date);
            temp.Driver = e.driver.name || '';
            temp['Driver Mobile'] = e.driver.mobile || '';
            // temp['Gate In No.'] = e.driver.gate_entry_no || '';
            // temp['Gate In Time'] = this.timeService.toShortDateTime24(e.events.filter((e) => e.event_name === 'GI')[0].event_timestamp);
            dataSource.push(temp);
          });
          const shipmentIds = res.map(r => r._id);
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                shipmentIds,
                shipmentType: 'all',
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  toogleinfo(type) {
    switch (type) {
      case 'actively':
        this.activelyTrackingInfo=!this.activelyTrackingInfo;
        break;
      case 'passivelytracking':
       this.passivelytrackingInfo=!this.passivelytrackingInfo;
        break;
        case 'non_tracking':
       this.nontrackingInfo=!this.nontrackingInfo;
        break;
        case 'no_gps':
          this.noGpsInfo=!this.noGpsInfo;
           break;
    }
  }
  showTowardsAngulDetails(item) {
    this.http.post('driver/details', { _ids: item.drivers }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data;
          const dataSource = [];
          const displayedColumns = ['SNo','Vehicle', 'Driver', 'Driver Mobile', 'Preferred Location', 'Carrier'];
          const title = item.title;
          res.forEach((e,i) => {
            const temp: any = {};
            temp.SNo=i+1;
            temp.Vehicle = e.vehicle_no;
            temp.Driver = e.name || '';
            temp['Driver Mobile'] = e.mobile || '';
            temp['Preferred Location'] = e.preferred_zone || e.preferred_location || '';
            temp.Carrier = e.carrier.name || '';
            temp.location = {latitude: e.geo_point.coordinates[1], longitude: e.geo_point.coordinates[0]}
            dataSource.push(temp);
          });
          if (dataSource.length) {
            this.dialogRef = this.dialog.open(CommonTableComponent, {
              data: {
                dataSource,
                displayedColumns,
                title,
                mapView: true,
              }
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

}
